module.exports = __webpack_public_path__ + "static/media/Dolores Kitchen Bookcases (3).88a58ee5.jpg";